import React, { useEffect, useState } from "react";
import { CommunityQuestionCss } from "../../styles/theme/communityQuestion";
import { CCarousel } from "@coreui/react";
import { CCarouselItem } from "@coreui/react";
import {
  ActionButton,
  CommunityAnswerInput,
  QuestionInput,
} from "../../styles/communityCommon";
import { GET_ALL_QUESTIONS, POST_ANS } from "../../api";
import { useCookies } from "react-cookie";

const CommunityQuestion = () => {
  const [cookies, setCookie] = useCookies(["authToken"]);
  const [isPosted, setIsPosted] = useState(false);

  const [questions, setQuestions] = useState([
    { question: "What is CSS?", questionId: "123" },
    { question: "What is JS Modal?", questionId: "124" },
    { question: "What is Chatgpt?", questionId: "125" },
  ]);

  const [answer, setAnswer] = useState("");

  useEffect(() => {
    GET_ALL_QUESTIONS()
      .then((res) => {
        console.log("ALL Questions::", res);

        let ques = res.data;

        setQuestions(ques);
      })
      .catch((er) => {
        console.log("Error while getting question:", er);
      });
  }, []);

  useEffect(() => {
    if (isPosted) {
      setTimeout(() => {
        setIsPosted(false);
      }, 2000);
    }
  }, [isPosted]);

  const postAnswerHanlder = (QuestionId) => {
    console.log("ANSWER::::", answer);
    POST_ANS(cookies.userID, QuestionId, answer)
      .then((res) => {
        console.log("Posting ans res:", res);

        setIsPosted(true);
      })
      .catch((er) => {
        console.log("Error while posting response:", er);
      });
  };

  return (
    <>
      <CommunityQuestionCss />
      <div className="community-container">
        <CCarousel controls interval={false} className="container">
          {questions.map((e) => {
            return (
              <CCarouselItem className="item">
                <div className="question-container">
                  {isPosted && (
                    <div className="success-msg">Posted Successfully!!</div>
                  )}
                  {!isPosted && (
                    <>
                      <div>{e.question}</div>
                      <div>
                        <CommunityAnswerInput
                          placeholder="Add an answer..."
                          onChange={(e) => {
                            setAnswer(e.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <ActionButton
                          onClick={() => {
                            postAnswerHanlder(e.id);
                          }}
                        >
                          Submit
                        </ActionButton>
                      </div>
                    </>
                  )}
                </div>
              </CCarouselItem>
            );
          })}
        </CCarousel>
      </div>
    </>
  );
};

export default CommunityQuestion;
